import { Component } from "react"
import PropTypes from "prop-types"
import { Card } from "@mui/material"
import { PERIOD, CHART_ITEM, DATE } from "helpers/shapes"
import PeriodSelector from "components/period-selector"
import PerformanceHistory from "components/performance-history"
import SelectedDate from "components/selected-date"
import PerformanceDetails from "modules/overview-performance-details"
import { percentageFormatter } from "helpers/formatters/numbers"
import NotEnoughData from "components/not-enough-data"
import "./style.scss"

export default class Performance extends Component {
  static propTypes = {
    startDate: DATE.isRequired,
    endDate: DATE.isRequired,
    cumulativeTrend: PropTypes.arrayOf(CHART_ITEM).isRequired,
    alphaTrend: PropTypes.arrayOf(CHART_ITEM).isRequired,
    factorTrend: PropTypes.arrayOf(CHART_ITEM).isRequired,
    tradingPnl: PropTypes.arrayOf(CHART_ITEM),
    period: PERIOD.isRequired,
    date: DATE,
    setDate: PropTypes.func.isRequired,
    setPeriod: PropTypes.func.isRequired,
    resetDate: PropTypes.func.isRequired,
    addNotification: PropTypes.func.isRequired,
    modelId: PropTypes.string.isRequired,
    portfolioId: PropTypes.string.isRequired,
    account: PropTypes.string.isRequired,
    earliestDate: DATE,
    latestDate: DATE,
    firstDate: DATE,
    isOpPro: PropTypes.bool.isRequired,
    datesAdjusted: PropTypes.bool.isRequired,
  }

  componentDidUpdate() {
    const { firstDate, startDate: propsStartDate, date } = this.props
    const startDate = firstDate || propsStartDate

    if (date && (date < startDate)) {
      this.props.resetDate()
    }
  }

  setPeriod = change => {
    if (change.startDate) {
      if (change.adjusted.startDate || change.adjusted.endDate) {
        this.props.addNotification("info", null, `The selected dates have been adjusted to the nearest available date range: ${change.adjusted.startDate || change.startDate} to ${change.adjusted.endDate || change.endDate}.`)
      }

      this.props.setPeriod({
        startDate: change.adjusted.startDate || change.startDate,
        endDate: change.adjusted.endDate || change.endDate,
      })
    } else {
      this.props.setPeriod(change)
    }
  }

  render() {
    const {
      cumulativeTrend, alphaTrend, factorTrend, tradingPnl, isOpPro,
      period, date, setDate, startDate, endDate, earliestDate, latestDate, resetDate, firstDate, modelId, portfolioId, account,
      datesAdjusted,
    } = this.props

    return <div className="modules_overview-performance">
      <Card square className="header">
        <div className="label">Performance Attribution</div>
        <PeriodSelector {...{ periodAdjusted: datesAdjusted, earliestDate, latestDate, endDate, startDate: firstDate || startDate, period, onChange: this.setPeriod }} />
        {date < endDate && <SelectedDate date={date} resetHandler={resetDate} performance />}
      </Card>
      <Card square className="content">
        {cumulativeTrend && cumulativeTrend.length > 0
          ? <>
            <PerformanceHistory {...{ date, endDate, startDate: firstDate || startDate, setDate, formatter: percentageFormatter, cumulativeTrend, alphaTrend, tradingPnl, factorTrend }} />
            <div className="details">
              <PerformanceDetails {...{ endDate: date, modelId }} />
            </div>
          </>
          : <NotEnoughData portfolio={portfolioId} account={account} isOpPro={isOpPro} />}
      </Card>
    </div>
  }
}
